import { submissions } from './sandboxSubmissions';

export const sandboxState = {
  is_sandbox: true,
  id: 'e7b41d42-b980-4ee2-aff4-b6dfea324ecf',
  peer_assessment_questions: [
    {
      question:
        'What did you find interesting or compelling about this submission?',
      is_active: true,
    },
    { question: 'Is there anything you had concerns about?', is_active: true },
    {
      question: 'Do you have suggestions for a different approach?',
      is_active: true,
    },
  ],
  title: 'Social Media and Society',
  submissions,
  points_settings: {
    peer_rewards: [
      {
        title: 'Critical Thinking',
        tag: 'all_critical_thinking',
        description: [
          'Uses reason and credible evidence to support claims and opinions',
          'Demonstrates ability to analyze and interpret class materials and ideas',
          'Asks thought-provoking questions where appropriate',
        ],
      },
      {
        title: 'Communication',
        tag: 'all_communication',
        description: [
          'Communicates ideas clearly and concisely',
          'Uses appropriate language and terminology',
          'Uses appropriate grammar and sentence structure',
        ],
      },
      {
        title: 'Collaboration',
        tag: 'all_collaboration',
        description: [
          'Demonstrates willingness and ability to consider different perspectives',
          'Provides constructive feedback to peers where appropriate',
          'Treats classmates with dignity and respect, even in disagreement',
        ],
      },
    ],
  },
  invites: [{ code: 'TzF0HdB7Y' }],
  course_id: '50491563-6957-4c0a-9b71-d820ee009308',
  reveal_names: false,
  is_active: true,
  is_published: true,
  is_premade: true,
  reflection_started: false,
  is_ended: false,
  published_date: '2018-07-19T20:21:52.648Z',
  prompt:
    '<h2>1. What are we talking about today?</h2>\n<p>Today we\'re going to be talking about social media, and how our lives and society might look different without it.</p>\n<h2>2. Why is it important / relevant?</h2>\n<p>Social media is a new phenomenon that is shaping society, and influencing us as individuals in ways we didn\'t anticipate. It is important that we understand how social media affects us so that we can make better decisions about how we should integrate into our lives.</p>\n<h2>3. Multimedia Content</h2>\n<p>First, take a look at these two resources on social media and its role in our society: <br /><br />Article: Are Social Networking Sites Good for our Society? <a href="https://socialnetworking.procon.org" target="_blank" rel="noopener">Click to read</a><br /><br /><iframe src="//www.youtube.com/embed/HffWFd_6bJ0" width="560" height="314" allowfullscreen="allowfullscreen"></iframe></p>\n<h2>4. Discussion Questions</h2>\n<p>Interesting, right? Now its your turn to think, reflect, and answer these three questions: <br /><br /><em><strong>1. What might your world look like without social media? </strong></em><br /><em><strong>2. How might your decision-making change? </strong></em><br /><em><strong>3. Would you prefer a world with less social media? Why or why not?</strong> </em><br /><br />Do some additional research to find information that supports your ideas. Be sure to share those links in your response.</p>\n<h2>5. Peer Feedback</h2>\n<p>When you join the discussion choose 3 of your peers\' responses to award points, leave feedback, and build on their ideas. <br /><br />Don\'t worry about being "right". The point of the RoundTable is to explore this idea, together. <br /><br />Stay Curious!</p>',
  sharing_settings: {
    idea_cloud: false,
    chord_diagram: false,
  },
  enable_grading: true,
  enable_annonymous: true,
  end_date: null,
  thumbnail_url:
    'https://parlayideas.com/wp-content/uploads/2017/10/Social-Media.png',
  point_cap: 1,
  created_at: '2018-07-19T20:21:31.916Z',
  author_id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
};

export const sandboxCourseDetailState = {
  id: '50491563-6957-4c0a-9b71-d820ee009308',
  title: 'parlay improvement',
  points_settings: {
    peer_rewards: [
      {
        title: 'Critical Thinking',
        tag: 'all_critical_thinking',
        description: [
          'Uses reason and credible evidence to support claims and opinions',
          'Demonstrates ability to analyze and interpret class materials and ideas',
          'Asks thought-provoking questions where appropriate',
        ],
      },
      {
        title: 'Communication',
        tag: 'all_communication',
        description: [
          'Communicates ideas clearly and concisely',
          'Uses appropriate language and terminology',
          'Uses appropriate grammar and sentence structure',
        ],
      },
      {
        title: 'Collaboration',
        tag: 'all_collaboration',
        description: [
          'Demonstrates willingness and ability to consider different perspectives',
          'Provides constructive feedback to peers where appropriate',
          'Treats classmates with dignity and respect, even in disagreement',
        ],
      },
      {
        tag: 'rt_well_written',
        title: 'Well-written',
        description: [
          'Communicates main ideas in a clear and concise manner',
          'Information and ideas are organized',
          'Sentences and paragraphs are smooth and fluent',
          'Appropriate use of language',
          'Attends to punctuation and grammar',
        ],
      },
      {
        tag: 'rt_inquiry',
        title: 'Inquiry',
        description: [
          'Demonstrates curiosity by asking thoughtful questions',
          'Poses new/deeper problems for independent investigation',
          'Makes predictions about possible outcomes or answers',
          'Discusses possible ways to learn more',
        ],
      },
      {
        tag: 'rt_creative',
        title: 'Creative',
        description: ['Thinks outside the box'],
      },
      {
        tag: 'ld_articulate',
        title: 'Articulate',
        description: [
          'Speaks clearly and confidently',
          'Eloquent and coherent arguments',
          'Communicates main ideas and in a clear and concise manner',
        ],
      },
      {
        tag: 'ld_respectful',
        title: 'Respectful',
        description: [
          'Demonstrates collaboration and critical thinking through insightful peer feedback',
          'Demonstrates good listening skills by being attentive and processing peer comments before responding',
          'Ability to disagree and counter arguments in an appropriate manner',
        ],
      },
      {
        tag: 'ld_prepared',
        title: 'Prepared',
        description: [
          'Actively engages with the material covered in lectures and readings by providing examples or explanations',
          'Prepares notes, opinions and questions in advance',
          'Investigates and/or conducts additional research for the discussion',
        ],
      },
      {
        tag: 'all_focus',
        title: 'Focus',
        description: [
          'Central message is clear and crafted with a strong awareness of audience and purpose',
          'Points are relevant and advance the discussion in a meaningful way',
          'Stays on topic',
        ],
      },
      {
        tag: 'all_evidence',
        title: 'Evidence',
        description: [
          'Supports answer with relevant examples, evidence and/or research',
          'Appropriate use of academic materials',
          'Cites sources and/or attaches additional documents ',
        ],
      },
      {
        tag: 'all_analysis',
        title: 'Analysis',
        description: [
          'Evaluates information and draws conclusions',
          'Identifies and explains the significance of the information',
          'Examines the text or topic in detail for the purpose of discussion or interpretation',
        ],
      },
      {
        tag: 'all_connection',
        title: 'Connection',
        description: [
          'Makes connections to a broader context (e.g. other texts, the course as a whole, applications in real world)',
          'Builds off of another student’s research and/or arguments',
          'Demonstrates text-to-text, text-to-self or text-to-world connections',
        ],
      },
      {
        tag: 'all_above_beyond',
        title: 'Above & Beyond',
        description: [
          'Explores related topics to deepen or extend understanding',
          'Considers alternative perspectives',
          'Shows genuine engagement by exceeding curriculum expectations',
        ],
      },
      {
        tag: 'all_expressive',
        title: 'Expressive',
        description: [
          'Expresses thoughts or challenges regarding beliefs, values, and attitudes of self and others',
          'Offers personal and unique perspective',
          'Appropriate use of tone and diction',
        ],
      },
    ],
  },
  sections: ['100'],
  tags: [],
  is_archived: false,
  meta: {
    student_invites: [],
  },
  created_at: '2017-10-25T15:58:45.317Z',
  users: [
    {
      id: '896f18ec-6fd1-41a5-a6e7-aacd1af91aca',
      name: 'Professor McGonagall',
      avatar_url:
        'http://img4.wikia.nocookie.net/__cb20150810173547/harrypotter/images/f/f9/PromoHP1_Minerva_McGonagall_2.jpg',
      subscription: {
        id: '8a8e626e-71f2-4d9e-a939-9f25fdde60ed',
        role: 'author',
      },
    },
    {
      id: '8c3f6c29-5ee6-4f3b-9b4e-484eacf49b55',
      name: 'Eric Chan',
      avatar_url: '/static/avatars/avatar_2.png',
      subscription: {
        id: 'bfaba681-0d1c-4ce1-9b80-f72b571f85a1',
        role: 'student',
      },
    },
    {
      id: '5a40c604-d093-4204-a019-1b2e10ab1af1',
      name: 'Jason Waterfalls',
      avatar_url: '/static/avatars/avatar_3.png',
      subscription: {
        id: 'ad812c52-9fb3-4ee2-80b4-8233257b147b',
        role: 'student',
      },
    },
    {
      id: 'ca04d134-00fe-4036-b3ba-8cbc531e0e74',
      name: 'Maria Pereira',
      avatar_url: '/static/avatars/avatar_4.png',
      subscription: {
        id: 'd7f851c1-5622-4ae5-b3ba-74ffc3bd105c',
        role: 'student',
      },
    },
    {
      id: 'c527820f-f326-4b52-92e2-883aca79c908',
      name: 'Miranda Devi',
      avatar_url: '/static/avatars/avatar_5.png',
      subscription: {
        id: '3f727a80-9637-49f5-8f71-9ad7082b7731',
        role: 'student',
      },
    },
    {
      id: 'b6e62156-cb3d-4f25-b920-61c98e8ecc26',
      name: 'Luke Walkersky',
      avatar_url: '/static/avatars/avatar_6.png',
      subscription: {
        id: '8ce0726b-2230-4e60-b3f5-b449ab6c669a',
        role: 'student',
      },
    },
    {
      id: 'bf374390-2007-4a33-9cee-65b265edc5b3',
      name: 'Harpreet Singh',
      avatar_url: '/static/avatars/avatar_7.png',
      subscription: {
        id: '5bd1d333-bad3-421a-ad52-f13b03399f7f',
        role: 'student',
      },
    },
    {
      id: 'e382ec0a-a2f8-4787-a141-aadaea7a2bef',
      name: 'Alice Nguyen',
      avatar_url: '/static/avatars/avatar_8.png',
      subscription: {
        id: '5ce599db-4b76-460d-b128-e386dfe1fdb4',
        role: 'student',
      },
    },
    {
      id: '22d00263-63e7-44c5-85e3-ef035ab1fed1',
      name: 'Daniel Muller',
      avatar_url: '/static/avatars/avatar_9.png',
      subscription: {
        id: 'd826dc54-1db8-4c02-a1be-50fcb94715df',
        role: 'student',
      },
    },
    {
      id: '619db365-0059-4d00-97eb-47d41b193e3a',
      name: 'Mia Tremblay',
      avatar_url: '/static/avatars/avatar_10.png',
      subscription: {
        id: '4c2a09c9-8611-465a-9ee1-7791bcf8456e',
        role: 'student',
      },
    },
    {
      id: 'd47332f7-16f5-4ff1-ae0a-d25887edc78c',
      name: 'Maxine Ahmed',
      avatar_url: '/static/avatars/avatar_11.png',
      subscription: {
        id: '6be13d0d-ac9f-401e-b647-6b61b8be5c43',
        role: 'student',
      },
    },
    {
      id: 'fa4169d3-979d-4769-89eb-9746e8e1c484',
      name: 'Ivan Kuznetsov',
      avatar_url: '/static/avatars/avatar_12.png',
      subscription: {
        id: '9bff5a20-69bd-48e3-a948-3651c09eb0df',
        role: 'student',
      },
    },
  ],
  invites: [{ code: 'Ika24F0UX' }],
};

const setCommentUserAndAnonynmousUser = (comment) => {
  const submissionOwner = sandboxState.submissions.find(
    (s) => s.real_id === comment.real_id
  );
  if (submissionOwner) {
    comment.user = submissionOwner.user;
    comment.anonymous_identity = submissionOwner.anonymous_identity;
  } else {
    comment.user = sandboxCourseDetailState.users.find(
      (u) => u.subscription.role === 'author'
    );
  }
  if (comment.children) {
    comment.children.forEach(setCommentUserAndAnonynmousUser);
  }
};

export const sandboxStatePatched = (function patchSandBoxState() {
  // Patch all submissions
  sandboxState.submissions.forEach((s) => {
    s.anonymous_identity = s.meta.anonymity_details;
    s.user = sandboxCourseDetailState.users.find((u) => u.id === s.real_id);
  });
  // Patch all comments in submissions
  sandboxState.submissions.forEach((s) => {
    if (s.comments) {
      s.comments.forEach(setCommentUserAndAnonynmousUser);
    }
  });
  return sandboxState;
})();



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/sandboxState.js